fragment EditionDashboardFragment on Edition {
    id
    name
    scheduledTime
    htmlUrlPath
    id
    audience {
        id
        membershipStats {
            totalCount {
                value
                suffix
                prefix
                formatted
            }
            totalCountFormatted
        }
    }
    engagementStats {
        clickRateFormatted
        totalSentCountFormatted
        openRateFormatted
    }
}
